<div class="card shadow-sm" [ngClass]="cardStyle">

  @if (title) {
    <div class="card-header" [ngClass]="headerStyle">
      <div class="row">
        <div class="col-12" [ngClass]="alignTitleCenter ? 'text-center': 'text-left'">
          <h4 class="d-inline">{{ title | translate | titlecase }}</h4>
          <div class="float-right">
            <ng-content select="[header-right]"></ng-content>
          </div>
        </div>
        <ng-content select="[header-subtitle]"></ng-content>
      </div>
    </div>
  }

  <div class="card-body" [class.noBottomPadding]="!bottomPadding">
    <ng-content></ng-content>
  </div>

</div>